var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-secondary bg-light p-1 d-inline-block"},[_vm._v(" "+_vm._s(_vm.$t('R.LIT_Empty'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }